import { Menu } from "@mui/icons-material";
import {
	AppBar,
	Box,
	FormControl,
	FormHelperText,
	IconButton,
	TextField,
	Toolbar,
	Tooltip,
	Typography
} from "@mui/material";
import { useState } from "react";
import { Person, SessionState, SettingsObject } from "../utils";
import { Details } from "./Details";
import { Profile } from "./Profile";

interface ProfilesProps {
	people: Person[];
	settings: SettingsObject;
	isMobile: boolean;
	openDrawer: () => void;
	sessionState: SessionState;
	setSessionState: (arg0: SessionState) => void;
	saveKeyPressed: boolean;
}

export function Profiles({
	isMobile,
	openDrawer,
	people,
	sessionState,
	setSessionState,
	saveKeyPressed,
	settings,
}: ProfilesProps) {
	// const [postStatus, setPostStatus] = useState<QueryStatus>(QueryStatus.IDLE);
	const [detailsModal, setDetailsModal] = useState<string | null>(null);
	const [selectedName, setSelectedName] = useState<string | null>(null);
	const [nameFilter, setNameFilter] = useState<string>("");

	const selectableNames = people.filter(
		({ roles, archived }) =>
			(roles.includes("attorney") || roles.includes("staff")) && !archived
	).filter(({name}) => name.toLowerCase().includes(nameFilter.toLowerCase()));

	return (
		<>
			<AppBar
				sx={
					isMobile
						? {}
						: { left: "200px", width: "calc(100% - 200px)" }
				}
			>
				<Toolbar>
					{isMobile && (
						<Tooltip title="Open Menu">
							<IconButton
								sx={{ color: "inherit", marginRight: 1 }}
								onClick={openDrawer}
							>
								<Menu />
							</IconButton>
						</Tooltip>
					)}
					<Typography
						variant="h6"
						color="inherit"
						component="div"
						sx={{ flex: 1 }}
					>
						Profiles
					</Typography>
				</Toolbar>
			</AppBar>
			<Box sx={{ top: "64px", position: "relative", width: "100%" }}>
				<FormControl sx={{ m: 1, minWidth: 300 }}>
					<TextField
						value={nameFilter}
						onChange={(event) => setNameFilter(event.target.value)}
					/>
					<FormHelperText>Filter Attorney/Staff</FormHelperText>
				</FormControl>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						flexWrap: "wrap",
					}}
				>
					{selectableNames.map((name) => (
						<Box
							sx={{
								borderRadius: "4px",
								border: (theme) =>
									`2px ${theme.palette.grey[800]} solid`,
								p: 1,
								background: (theme) => theme.palette.grey[900],
								width: "200px",
								m: 1,
								"&:hover": (theme) => ({
									background: theme.palette.primary.dark,
									border: `2px ${theme.palette.primary.light} solid`,
								}),
								cursor: 'pointer'
							}}
							onClick={()=> setSelectedName(name._id)}
						>
							<Typography color="white">{name.name}</Typography>
						</Box>
					))}
				</Box>
			</Box>

			<Profile
				people={people}
				selectedName={selectedName}
				sessionState={sessionState}
				setSessionState={setSessionState}
				setDetailsModal={setDetailsModal}
				onClose={() => setSelectedName(null)}
			/>
			<Details
				people={people}
				saveKeyPressed={saveKeyPressed}
				detailsModal={detailsModal}
				settings={settings}
				id={detailsModal || ""}
				onClose={() => setDetailsModal(null)}
				sessionState={sessionState}
				setSessionState={setSessionState}
			/>
		</>
	);
}
